export default __webpack_public_path__ + "static/media/css.855415e6.svg";